import { IRouter } from './interface';
import { routerActive, routerHome } from '@view/Home/router';

export const privatePage: IRouter[] = [routerHome];

export const publicPage: IRouter[] = [routerHome, routerActive];
